import React, { memo, useEffect, useRef, useState } from 'react';
import LazyImage from '../../CustomLibraries/LazyImage';
import { Button, Form } from 'react-bootstrap';
import '../../../assets/sass/uiV3/component/_comments.scss';
import { useDispatch, useSelector } from 'react-redux';
import { GetComments, GetReplyComments, PostComment } from '../../../Store/actions';
import { isMobile } from 'react-device-detect';
import { CLICK_SUBMIT_COMMENT_BUTTON, EVENT } from '../../../TrackerFolder/constants/ActionType';
import { trackEvent } from '../../../TrackerFolder/actions';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import { likePress } from '../../../Store/actions/grandround.action';
import { onCommentSubmitButtonPress } from '../../../TrackerFolder/actions/FeedActions';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import TooltipContainer from './TooltipContainer';

var commentPaginationStart = 0;
var showNewComment = false;
var replyPaginationStart = 0;

const Comments = ({ id, type, page }) => {
  const [disabled, setDisabled] = useState(false);
  const [commentBoxLabel, setCommentBoxLabel] = useState('Write a comment here');
  const [showCommentArea, setShowCommentArea] = useState(true);
  const [replySelectedIndex, setReplySelectedIndex] = useState(-1);
  const [comments, setComments] = useState([]);
  const [mainComment, setMainComment] = useState('');
  const [loader, setLoader] = useState(true);
  const [viewMoreReplybtn, setViewMoreReplyBtn] = useState(true);
  const [primaryCommentId, setPrimaryCommentId] = useState(0);
  const userDet = useSelector((state) => state.common.user_details);

  const commentRef = useRef();
  const dispatch = useDispatch();
  const getComments = () => {
    dispatch(
      GetComments(id, type, commentPaginationStart, 3, (res) => {
        if (res != 'error') {
          // console.log(res.data);

          if (commentPaginationStart == 0) {
            setShowCommentArea(true);
          }

          if (res.data[0] == null) {
            setShowCommentArea(false);
            setLoader(false);
          }

          if (showNewComment) {
            setComments(res.data);
          } else {
            setComments((prevArray) => {
              return [...prevArray, ...res.data];
            });
          }

          showNewComment = false;
          setLoader(false);
        }
      })
    );
  };

  useEffect(() => {
    showNewComment = true;
    getComments();
  }, [id]);

  const GetReplies = (index, commentId) => {
    setLoader(true);
    replyPaginationStart = 0;
    if (comments[index].children.length === 0) {
      dispatch(
        GetReplyComments(commentId, replyPaginationStart, 5, (res) => {
          if (res != 'error') {
            const newCommentsData = [...comments];
            newCommentsData[index].children = res.data;
            newCommentsData[index].active = true;
            setComments(newCommentsData);
            setViewMoreReplyBtn(true);
            setLoader(false);
          }
        })
      );
    } else {
      const newCommentsData = [...comments];
      newCommentsData[index].active = true;
      setComments(newCommentsData);
      setLoader(false);
    }
  };
  const { trackActivityEvent } = useTracker();

  const getMoreComments = () => {
    trackActivityEvent(EVENT, trackEvent('CLICK_VIEW_MORE_COMMENTS'));
    commentPaginationStart = commentPaginationStart + 3;
    setLoader(true);
    getComments();
  };
  const handleLikingComment = (type_id) => {
    const commentsList = [...comments];

    let baseIndex = -1;
    let replyIndex = -1;
    for (var i = 0; i < commentsList.length; i++) {
      if (commentsList[i].commentId == type_id) {
        baseIndex = i;
        break;
      } else {
        if ('children' in commentsList[i] && commentsList[i].children.length > 0) {
          for (var j = 0; j < commentsList[i].children.length; j++) {
            if (commentsList[i].children[j].commentId == type_id) {
              replyIndex = j;
              break;
            }
          }
        }
      }
    }

    if (baseIndex !== -1 && replyIndex !== -1) {
      console.log('comment level if');

      if (commentsList[baseIndex].children[replyIndex].liked) {
        commentsList[baseIndex].children[replyIndex].rating =
          parseInt(commentsList[baseIndex].children[replyIndex]?.rating ?? 0) - 1;
      } else {
        commentsList[baseIndex].children[replyIndex].rating =
          parseInt(commentsList[baseIndex]?.children[replyIndex]?.rating ?? 0) + 1;
      }
      commentsList[baseIndex].children[replyIndex].liked =
        !commentsList[baseIndex].children[replyIndex].liked;
    } else if (baseIndex !== -1) {
      console.log('comment level else if');
      if (commentsList[baseIndex].liked) {
        console.log('comment level else if if');

        commentsList[baseIndex].rating = parseInt(commentsList[baseIndex]?.rating ?? 0) - 1;
      } else {
        console.log('comment level else else');

        commentsList[baseIndex].rating = parseInt(commentsList[baseIndex]?.rating ?? 0) + 1;
      }
      commentsList[baseIndex].liked = !commentsList[baseIndex].liked;
    }

    setComments(commentsList);
  };
  const onLikePress = (type_id, type) => {
    handleLikingComment(type_id);
    dispatch(
      likePress({ type_id, type }, (res) => {
        if (res?.data) {
          console.log('====>>', res?.data);
        }
      })
    );
  };

  const activateReply = (id, name) => {
    setPrimaryCommentId(id);
    setCommentBoxLabel('Reply to ' + name);
    commentRef.current.focus();
  };

  const submitComment = (type_id, type) => {
    if (mainComment != '') {
      trackActivityEvent(
        CLICK_SUBMIT_COMMENT_BUTTON,
        onCommentSubmitButtonPress(page, mainComment)
      );
      let parser = {
        type_id: type_id,
        type: type,
        parent_id: 0,
        comment: mainComment,
        primary_comment_id: primaryCommentId
      };
      // showCommentArea(true)
      setDisabled(true);
      dispatch(
        PostComment(parser, (response) => {
          if (response != 'error') {
            if (response.status_code == 200) {
              setMainComment('');
              commentPaginationStart = 0;
              setPrimaryCommentId(0);
              getComments();
              setDisabled(false);
            }
          }
        })
      );
    } else {
      toast.error('Please write your comment');
      setDisabled(false);
    }
  };
  const getMoreReplies = (index, commentId) => {
    if (comments[index].children.length > 0) replyPaginationStart = comments[index].children.length;
    else replyPaginationStart = replyPaginationStart + 5;
    trackActivityEvent(EVENT, trackEvent('CLICK_VIEW_MORE_REPLIES'));
    dispatch(
      GetReplyComments(commentId, replyPaginationStart, 5, (res) => {
        if (res != 'error') {
          if (res.data.length > 0 && res.data[0] != null) {
            const newCommentsData = [...comments];
            newCommentsData[index].children = [...newCommentsData[index].children, ...res.data];
            setComments(newCommentsData);
          } else {
            setViewMoreReplyBtn(false);
          }

          setLoader(false);
        }
      })
    );
  };

  const hideReplies = (index) => {
    const newCommentsData = [...comments];
    newCommentsData[index].active = false;
    setComments(newCommentsData);
  };

  dayjs.extend(relativeTime);
  return (
    <div className="clr_v3_comments d-flex flex-column">
      <div
        id="commentBox"
        className={`clr_v3_comments__form d-flex align-items-center gap-3 ${
          isMobile ? 'position-fixed bg-white fixed-bottom p-3' : 'mb-md-20 position-relative'
        }`}
      >
        <div className="rounded-circle p-33 border border-105 border-primary position-relative me-auto flex-shrink-0">
          {/* profile image full */}
          <div
            className="overflow-hidden clr_v3_userImage rounded-circle position-relative d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: '#F3c'
            }}
          >
            <LazyImage
              src={userDet.profile_image}
              width=""
              height=""
              alt="Dr. User Image"
              className="object-fit-cover w-100 h-100 float-start"
            />
            {/* <span className='text-white fs-2 fw-semibold'>A</span> */}
          </div>
        </div>
        <Form
          className="w-100 position-relative "
          onSubmit={(e) => {
            e.preventDefault();
            showNewComment = true;
            submitComment(id, type);
          }}
        >
          <Form.Floating className="position-relative w-100">
            <Form.Control
              id="CommentBoxInput"
              className={`fs-4  bg-transparent`}
              placeholder={commentBoxLabel}
              ref={commentRef}
              onBlur={() => setCommentBoxLabel('Write a comment here')}
              onChange={(e) => setMainComment(e.target.value)}
              value={mainComment}
            />
            <label htmlFor="floatingInputCustom fw-semibold">{commentBoxLabel}</label>
          </Form.Floating>
          {/* rippleEffect p-0 border-0
                rounded-circle
                bg-transparent
                icon-size-32
                d-inline-flex
                position-absolute
                top-50
                translate-middle-y
                justify-content-center
                align-items-center */}
          {/* <TooltipContainer text="Send" placement="bottom"> */}
          <Button
            variant="white"
            type="submit"
            className="p-0 border-0 top-50 translate-middle-y icon-size-32 icon-size-sm-36 transition cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-absolute fs-2 clr_v3_icon-btn-1 text-black"
            aria-label="Submit"
          >
            <i class="flaticon-send"></i>
          </Button>{' '}
          {/* </TooltipContainer> */}
        </Form>
      </div>

      <div className="d-flex flex-column gap-sm-20 gap-4">
        {comments &&
          comments.length > 0 &&
          comments.map((comment, index) => {
            if (comment === null) return null;
            const {
              name,
              body,
              images,
              first_name,
              commentId,
              liked,
              created_at,
              children,
              active = false
            } = comment || {};
            {
              console.log('comments', comment, liked);
            }

            return (
              <div
                className="clr_v3_comments__row d-flex flex-column gap-sm-4 gap-3"
                key={commentId}
              >
                <div className="d-flex gap-3 align-items-start">
                  <div className="rounded-circle p-33 border border-105 border-light position-relative flex-shrink-0 ">
                    <div
                      className="overflow-hidden clr_v3_userImage rounded-circle position-relative d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: '#F3c'
                      }}
                    >
                      {images && images !== '' && (
                        <LazyImage
                          src={images}
                          width=""
                          height=""
                          alt="Dr. User Image"
                          className="object-fit-cover w-100 h-100 float-start"
                        />
                      )}

                      {!images && images == '' && (
                        <span className="text-white fs-2 fw-semibold">{first_name[0]}</span>
                      )}
                    </div>
                  </div>
                  <div className="flex-grow-1 d-flex flex-column gap-1">
                    <h4 className="fs-4 text-black fw-medium">
                      {name}
                      <span className="ms-2 d-inline-block fs-5 fw-normal text-dark">
                        {dayjs(created_at).fromNow()}
                      </span>
                    </h4>
                    <h4 className="fs-4 text-dark">{body}</h4>
                    <div className="gap-4 d-flex align-items-center me-auto flex-wrap">
                      <a
                        className="text-black d-inline-block me-auto mt-1 fs-5"
                        role="button"
                        onClick={() => activateReply(commentId, name)}
                      >
                        Reply
                      </a>
                      {active ? (
                        <a
                          role="button"
                          className="text-black d-inline-block me-auto mt-1 fs-5"
                          onClick={() => hideReplies(index)}
                        >
                          Hide Replies
                          {/* <span className="fs-6 text-black">(02)</span>{" "} */}
                        </a>
                      ) : (
                        <a
                          role="button"
                          className="text-black d-inline-block me-auto mt-1 fs-5"
                          onClick={() => GetReplies(index, commentId)}
                        >
                          Show Replies
                        </a>
                      )}
                    </div>
                  </div>
                  <a
                    role="button"
                    className={`icon-size-32 text-dark rounded-circle d-inline-flex transition rippleEffect bg-transparent clr_v3_icon-btn-1 text-dark flex-shrink-0 fs-2 cursorPointer`}
                    onClick={() => onLikePress(commentId, 'comment', false)}
                  >
                    <TooltipContainer text={liked ? 'Unlike' : 'Like'} placement="top">
                      {liked ? (
                        <i className="flaticon-heart-1 text-primary position-absolute translate-middle top-50 start-50"></i>
                      ) : (
                        <i className="flaticon-heart position-absolute translate-middle top-50 start-50"></i>
                      )}
                    </TooltipContainer>
                  </a>
                </div>
                {active &&
                  children &&
                  children.length > 0 &&
                  children.map((child) => {
                    if (child === null) return null;
                    const { images, created_at, commentId, name, body } = child || {};

                    return (
                      <div
                        className="clr_v3_comments__row d-flex flex-column gap-sm-4 gap-3 ps-sm-50 ps-5"
                        key={commentId}
                      >
                        <div className="d-flex gap-3 align-items-start">
                          <div className="rounded-circle p-33 border border-105 border-light position-relative flex-shrink-0 ">
                            <div
                              className="overflow-hidden clr_v3_userImage rounded-circle position-relative d-flex align-items-center justify-content-center"
                              style={{
                                backgroundColor: '#F3c'
                              }}
                            >
                              {images && images !== '' && (
                                <LazyImage
                                  src={images}
                                  width=""
                                  height=""
                                  alt="Dr. User Image"
                                  className="object-fit-cover w-100 h-100 float-start"
                                />
                              )}

                              {!images && images == '' && (
                                <span className="text-white fs-2 fw-semibold">{first_name[0]}</span>
                              )}
                            </div>
                          </div>
                          <div className="flex-grow-1 d-flex flex-column gap-1">
                            <h4 className="fs-4 text-black fw-medium">
                              {name}
                              <span className="ms-2 d-inline-block fs-5 fw-normal text-dark">
                                {dayjs(created_at).fromNow()}
                              </span>
                            </h4>
                            <h4 className="fs-4 text-dark">{body}</h4>
                          </div>
                          <a
                            role="button"
                            className={`icon-size-32 text-dark rounded-circle d-inline-flex transition rippleEffect bg-transparent clr_v3_icon-btn-1 text-dark flex-shrink-0 fs-2 cursorPointer`}
                            onClick={() => onLikePress(commentId, 'comment', false)}
                          >
                            {liked ? (
                              <i className="flaticon-heart-1 text-primary position-absolute translate-middle top-50 start-50"></i>
                            ) : (
                              <i className="flaticon-heart position-absolute translate-middle top-50 start-50"></i>
                            )}
                          </a>
                        </div>
                      </div>
                    );
                  })}

                {active &&
                  viewMoreReplybtn &&
                  children &&
                  children.length > 2 &&
                  children[0] !== null && (
                    <Button
                      variant="extra-light"
                      className="py-2 ms-sm-50 ms-5 me-auto text-dark"
                      onClick={() => getMoreReplies(index, commentId)}
                      disabled={loader}
                    >
                      Load More
                    </Button>
                  )}
              </div>
            );
          })}

        {showCommentArea && (
          <Button
            variant="extra-light"
            className="py-3 text-dark"
            onClick={getMoreComments}
            disabled={loader}
          >
            Load More
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(Comments);
